export default __webpack_public_path__ + "static/media/origynLogo.d2359a16.svg";